import { Typography } from "@mui/material";
import { Dialog } from "components/Dialog";
import { documentKindNames, documentTitle } from "encamp-shared/src/waste/shippingDocumentLabels";
import { ShippingDocumentKind } from "generated-graphql/graphql";

/**
 * Detach spells out the consequences because they reach past this shipment: the
 * containers stop pointing at the manifest's waste lines, and auto-match is
 * suppressed so the pipeline does not immediately undo the decision.
 */
export function DetachManifestDialog({
  trackingNumber,
  documentKind,
  detaching,
  onConfirm,
  onClose,
}: {
  trackingNumber: string | null;
  documentKind: ShippingDocumentKind | null;
  detaching: boolean;
  onConfirm: () => void;
  onClose: () => void;
}) {
  const noun = documentKindNames(documentKind).noun;
  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="xs"
      title={`Detach this ${noun}?`}
      primaryActionButtonProps={{
        saveText: `Detach ${noun}`,
        loading: detaching,
        onClick: onConfirm,
      }}
    >
      <Typography variant="body2">
        {trackingNumber
          ? documentTitle({
              documentKind,
              manifestTrackingNumber: trackingNumber,
            })
          : `This ${noun}`}{" "}
        will be unlinked, and the containers on this shipment will no longer point at its waste
        lines. The {noun} itself is not deleted, and this shipment&apos;s contents become editable
        again. Automatic matching will not re-link this {noun} on its own — link it by hand if you
        detached it in error.
      </Typography>
    </Dialog>
  );
}
